module.exports = __webpack_public_path__ + "../resources/img/ic_re_wifi_off_p2.386a4e35.svg";